import { ThermoboxCustomModalCell } from './components/thermobox-custom-modal-cell';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const THERMOBOX_FORM_NAME = 'thermobox-form';

export const THERMOBOX_TABLE_COLUMNS_NAMES = [
	{ id: 'title' },
	{ id: 'value', customComponent: ThermoboxCustomModalCell },
];

export const THERMOBOX_TABLE_ROWS_NAMES = {
	partner: 'Производитель',
	outer: 'Внешние геометрические размеры',
	outerVolume: 'Внешний объем',
	inner: 'Внутренние геометрические размеры',
	innerVolume: 'Внутренний объем',
	emptyWeight: 'Масса пустого',
	pallet: 'Габариты паллета',
	palletWeight: 'Масса паллета',
	totalHeight: 'Общая высота',
	totalWeight: 'Общая масса',
	author: 'Автор',
};

export const REQUIRED_FIELDS = [
	'name',
	'partner_id',
	'outer_length',
	'outer_width',
	'outer_height',
	'inner_length',
	'inner_width',
	'inner_height',
	'empty_weight',
];

export const FIELDS_FOR_VALIDATE = [
	'name',
	'partner_id',
	'outer_length',
	'outer_width',
	'outer_height',
	'inner_length',
	'inner_width',
	'inner_height',
	'empty_weight',
	'pallet_length',
	'pallet_width',
	'pallet_height',
	'pallet_weight',
];
